import { render, staticRenderFns } from "./image_block.vue?vue&type=template&id=2fada801&scoped=true&"
import script from "./image_block.vue?vue&type=script&lang=js&"
export * from "./image_block.vue?vue&type=script&lang=js&"
import style0 from "./image_block.vue?vue&type=style&index=0&id=2fada801&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fada801",
  null
  
)

export default component.exports